import {
  fetchCatAttributeStart,
  fetchCatAttributeSuccess,
  fetchCatAttributeFailure,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ATTRIBUTE_BY_CATEGORY } from "../../constants/constants";

export const getCatAttribute =
  (category, setLoading) => async (dispatch) => {
    try {
      setLoading(true);

      dispatch(fetchCatAttributeStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ATTRIBUTE_BY_CATEGORY(category),
        "GET"
      );

      setLoading(false);

      dispatch(fetchCatAttributeSuccess(response));
    } catch (error) {
      setLoading(false);

      dispatch(fetchCatAttributeFailure(error.message));
    }
  };